import Navbar from "@/components/navbar";
import HeroSection from "@/components/hero-section";
import LeadForm from "@/components/forms/LeadForm";
import BenefitsSection from "@/components/benefits-section";
import Footer from "@/components/footer";
import { FORM_CONFIGS, type FormConfigKey } from "@/config/forms";

/**
 * Shared marketing funnel: Navbar + Hero + LeadForm + Benefits + Footer.
 *
 * Used by every route whose only difference is the form ID. Adding a new
 * funnel route is two edits:
 *   1. Add a `FORM_CONFIGS` entry.
 *   2. `<Route path="/new" element={<LeadFunnelPage configKey="newKey" />} />`
 */
export type LeadFunnelPageProps = {
  configKey: FormConfigKey;
  /** Optional PDF asset to deliver on success (used by /ai-roadmap). */
  pdfPath?: string;
};

export default function LeadFunnelPage({
  configKey,
  pdfPath,
}: LeadFunnelPageProps) {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-black font-fira max-w-2xl mx-auto px-4 py-8 sm:py-16 flex flex-col gap-16">
        <HeroSection />
        <section id="join" className="scroll-mt-28">
          <LeadForm config={FORM_CONFIGS[configKey]} pdfPath={pdfPath} />
        </section>
        <BenefitsSection />
        <Footer />
      </main>
    </>
  );
}
